{
  "startNew": "Commencer nouveau",
  "table": {
    "createdAt": "Exécuté à",
    "createdBy": "Exécuté par",
    "state": "État",
    "organization": "Organisation"
  },
  "fileTable": {
    "order": "Commande",
    "createdAt": "Téléchargé à",
    "name": "Nom",
    "type": "Type d'importation",
    "totalLineItems": "Nombre de lignes",
    "queuedLineItems": "Nombre en fille d'attente",
    "failedLineItems": "Nombre d'échecs",
    "processedLineItems": "Nombre traité",
    "state": "État",
    "actions": "Actions",
    "menu": {
      "delete": "Supprimer",
      "process": "Traiter"
    }
  },
  "resumeProcessButton": "Reprendre",
  "processBulkImportMessage": "L'importation en masse est en cours de traitement.",
  "deleteFileMessage": "Le fichier a été supprimé.",
  "resumeFileConfirmationDialog": {
    "title": "Reprendre le traitement du fichier",
    "text": "Voulez-vous vraiment reprendre le traitement du fichier?"
  },
  "deleteFileConfirmationDialog": {
    "title": "Supprimer le fichier",
    "text": "Voulez-vous vraiment supprimer le fichier?"
  },
  "lineItemTable": {
    "externalId": "Identifiant de l'élément",
    "oneVestId": "Identifiant OneVest",
    "state": "État"
  },
  "fileTypes": {
    "USER": "Clients",
    "GOAL": "Objectifs",
    "ACCOUNT": "Comptes",
    "ACCOUNT_AFFILIATE": "Affiliés du compte",
    "TRANSACTION": "Transactions",
    "SECURITY_PRICE": "Historique des prix des valeurs immobilières",
    "PRODUCT_SHELF": "Étagère de produits",
    "FOREIGN_EXCHANGE_RATE": "Taux de change",
    "PORTFOLIO_SECURITIES": "Titres de portefeuille"
  },
  "states": {
    "INITIATED": "INITIÉ",
    "PROCESSING": "TRAITEMENT",
    "FAILED": "ÉCHEC",
    "CANCELED": "ANNULÉ",
    "COMPLETED": "TERMINÉ",
    "QUEUED": "EN ATTENTE",
    "PARTIALLY_FAILED": "ÉCHEC PARTIEL",
    "PROCESSED": "TRAITÉ"
  },
  "lineItemModal": {
    "title": "Détails de l'élément",
    "errorTitle": "Erreurs",
    "errorCode": "Code",
    "errorField": "Champ",
    "errorDescription": "Description",
    "save": "Enregistrer",
    "addBackToQueue": "Ajouter l'élément à la file d'attente"
  },
  "addFile": "Ajouter le fichier",
  "addFileModal": {
    "title": "Ajouter le fichier d'importation",
    "type": "Type d'importation",
    "downloadTemplateButton": "Télécharger le modèle",
    "button": "Importer"
  },
  "bulkImportOn": "Importé le",
  "notSureHowToFormat": "Vous ne savez pas comment formater votre CSV? Utilisez notre",
  "template": "modèle",
  "copyAndPaste": "Copier et coller des titres",
  "errorFetchingTemplate": "Erreur lors de la récupération du modèle : {{error}}",
  "downloadTemplate": "Télécharger le modèle",
  "importCsvFile": "Importer un fichier CSV",
  "pasteDescription": "Importez un fichier CSV pour ajouter rapidement des titres à votre portefeuille. Veuillez vous assurer que votre CSV inclut les colonnes suivantes : Security Identifier (Ticker), Poids cible %, Tax Rank (optional).",
  "pasteCsv": "Coller CSV",
  "pastePlaceholder": "",
  "errors": {
    "emptyPaste": "Veuillez coller le contenu CSV",
    "invalidContent": "Contenu CSV invalide : {{error}}",
    "processFailed": "Échec du traitement du contenu collé",
    "unknownError": "Erreur inconnue"
  },
  "success": {
    "imported": "{{fileName}} importé avec succès",
    "uploaded": "Document téléversé avec succès : {{fileName}}"
  }
}
